"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsAndConditions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
var Layout_1 = __importDefault(require("../Layout"));
var terms_and_conditions_docx_1 = __importDefault(require("../../static/docs/terms-and-conditions.docx"));
// The source .docx's intro paragraph ends with a reference to the
// "Términos y Condiciones Comunes" companion document, marked with an
// endnote [1] whose definition lives in an <ol> at the very bottom of the
// document. Strip both (kept out of the .docx itself since we can't edit
// binary Word files here): the inline reference clause, and the now-orphan
// endnote entry it pointed to.
var content = terms_and_conditions_docx_1.default
    .replace(/\s*Asimismo considerar como complemento el documento[\s\S]*?<\/strong>/, '')
    .replace(/<ol>\s*<li id="endnote-1">[\s\S]*?<\/ol>/, '');
function TermsAndConditions() {
    return ((0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsx)(styles_1.Content, { dangerouslySetInnerHTML: { __html: content } }) }));
}
exports.TermsAndConditions = TermsAndConditions;
